import LoginBackground from "../assets/background.png";
import login_Logo from "../assets/logo.svg";
import dp from "../assets/dp.png";
import InputBg from "../assets/uploadbg.svg";
import downarrow from "../assets/down-arrow.svg";
import downarrowwhite from "../assets/down-arrow1.svg";
import calIcon from "../assets/calBg.png";
import docIcon from "../assets/Doc.svg";
import logoutIcon from "../assets/logout.svg";
import profileIcon from "../assets/profile.svg";
import invoice from "../assets/invoice.svg";
import roomImage from "../assets/roomImage.svg";
import rightLink from "../assets/right-link.svg";
import leftLink from "../assets/left-link.svg";
import media from "../assets/media.svg";
import sendIcon from "../assets/sendicon.svg";
import disabledIcon from "../assets/disabledIcon.svg";
import DownloadMedia from "../assets/downloadMedia.svg";
import DeleteMedia from "../assets/deleteMedia.svg";
import PlayMedia from "../assets/playMedia.svg"
import mediaIcon from "../assets/mediaIcon.svg"
import VidThumbnail from '../assets/VidThumbnail.svg'
import VideoThumbForBackend from '../assets/VideoThumb.png'
import MediaEye from '../assets/MediaEye.svg'
import ApprovedIcon from '../assets/approvedIcon.svg'
import FilterIcon from "../assets/FilterIcon.svg"
import DashboardBuilding from "../assets/DashboardBuilding.svg"
import DashboardUnits from "../assets/DashboardUnits.svg"
import DashboardTenants from "../assets/DashboardTenants.svg"
import DashboardUnitsRents from "../assets/DashboardUnitsRents.svg"





export {
  DashboardBuilding,
  DashboardUnitsRents,
  DashboardTenants,
  DashboardUnits,
  ApprovedIcon,
  FilterIcon,
  VidThumbnail,
  LoginBackground,
  login_Logo,
  dp,
  InputBg,
  downarrow,
  downarrowwhite,
  calIcon,
  sendIcon,
  disabledIcon,
  docIcon,
  logoutIcon,
  profileIcon,
  invoice,
  roomImage,
  rightLink,
  leftLink,
  media,
  DownloadMedia,
  MediaEye,
  DeleteMedia,PlayMedia,mediaIcon,VideoThumbForBackend
};
